import groupByDate from '@/utils/groupByDate';

export default {
  TASKS: (state) => groupByDate(state.tasks),
  TASK: (state) => state.task,
};
